import React from 'react';
import type { FormFieldProps } from 'semantic-ui-react';
import type { TimeZone } from '@axiom/validation';

import { FormField } from '../FormField/FormField';
import type { IconName } from '../../element/Icon/icon.types';

import type { RawTimezoneDropdownProps } from './RawTimezoneDropdown';
import { RawTimezoneDropdown } from './RawTimezoneDropdown';

export type TimezoneDropdownProps = {
  description?: string;
  direction?: RawTimezoneDropdownProps['direction'];
  disabled?: boolean;
  icon?: IconName;
  id?: string;
  label?: React.ReactNode;
  name: string;
  onBlur?: (value?: TimeZone['id'] | null) => void;
  onChange?: (
    value: TimeZone['id'] | null,
    e?: React.SyntheticEvent<HTMLElement>,
    timezone?: TimeZone
  ) => void;
  onFocus?: (value?: TimeZone['id'] | null) => void;
  placeholder?: string | null;
  Tooltip?: React.ReactNode;
};

const DEFAULT_LABEL = 'Time zone';
const noopFn = () => {};

export const TimezoneDropdown = ({
  description,
  direction,
  disabled,
  icon,
  id,
  label = DEFAULT_LABEL,
  name,
  onBlur = noopFn,
  onChange = noopFn,
  onFocus = noopFn,
  placeholder,
  Tooltip,
}: TimezoneDropdownProps) => {
  id = id || name;

  return (
    <FormField
      {...{
        description,
        disabled,
        icon,
        id,
        name,
        label,
        onClear: (v: TimeZone['id'] | null) => {
          onChange(v);
        },
        Tooltip,
      }}
      renderField={({
        value,
        onBlur: formOnBlur,
        setFieldValue,
        invalid,
      }: {
        value: RawTimezoneDropdownProps['value'];
      } & FormFieldProps) => (
        <RawTimezoneDropdown
          direction={direction}
          disabled={disabled}
          id={id}
          invalid={invalid}
          name={name}
          onBlur={e => {
            onBlur(e.target.value);
            formOnBlur({ ...e, target: { ...e.target, name } });
          }}
          onChange={(v, e, timezone) => {
            onChange(v, e, timezone);
            setFieldValue(name, v);
          }}
          onFocus={() => {
            onFocus();
          }}
          placeholder={placeholder}
          value={value}
        />
      )}
    />
  );
};
